import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { L10nTranslationService } from 'angular-l10n';
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  header= this.L10nTranslationService.translate('Services');
  description= this.L10nTranslationService.translate('Learn about the services provided by our experts to support you in implementing your cybersecurity programs');
  joinChat: boolean = false;
  imagePath = "../../../../assets/images/undraw_mobile_search_jxq5 1.png";
  hasBtn: boolean = false;
  items: string[];
  isActiveAwareness: boolean = false;
  isActiveCompliance: boolean = false;
  isActiveConsultations: boolean = false;
  tileSectionTwo: string;
  descriptionSectionTwo: string;
  imgListPath: string = '../../../../assets/images/undraw_collaborating.png'
  routerListButton: string = '/contact-us';
  buttonListText: string = 'Contact us';
  constructor(private route: ActivatedRoute, private L10nTranslationService: L10nTranslationService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      // PARAMS CHANGED ..
      let id = params['id'];
      if(id) {
        this.cardSwap(id)
      } else {
        this.cardSwap('Awareness')
      }
    });

  }

  cardSwap(cardActive: string) {
    if (cardActive === 'Awareness') {
      this.isActiveAwareness = true
      this.isActiveCompliance = false
      this.isActiveConsultations = false
      this.items = [
        'Design and manage a phishing awareness and simulation program through your facility account in our platform',
        'Issuing periodic reports and performance indicators to ensure accuracy in following up on your program',
        'This service saves you from the need to bear the burdens of adding human resources and other operational costs',
        'Providing training workshops and simulating attacks for the executive management and all employees at the headquarters of your facility',
        'We apply the highest standards of data security to keep your program information private to you'
      ];
      this.tileSectionTwo = 'Managed Awareness'
      this.descriptionSectionTwo = 'We provide you with an integrated team to manage cyber awareness programs and phishing simulations in your facility on your behalf, based on a scope of work that you define in proportion to your needs'
    }
    if (cardActive === 'Compliance') {
      this.isActiveCompliance = true
      this.isActiveAwareness = false
      this.isActiveConsultations = false
      this.items = [
        'Saudi Aramco Certificate of Commitment (SACS02)',
        "PCI DSS Certification",
        'ISO certificates'
      ];
      this.tileSectionTwo = 'Certification'
      this.descriptionSectionTwo = 'We provide you with our accumulated experience in preparing your facility to obtain the mark of excellence and to achieve compliance with local and international regulations that suit the scope of your facilitys work Our services cover different fields of work'
    }
    if (cardActive === 'Consultations') {
      this.isActiveConsultations = true
      this.isActiveAwareness = false
      this.isActiveCompliance = false
      this.items = [
        'Issuing a compliance status report and estimating the current maturity level based on the required controls and methodologies',
        "Draw up a time plan for solving current problems and clarify tasks and responsibilities",
        'Implementing the practical plan and building governance, risk and compliance management programs',
        "Issuing final reports and documenting results"
      ];
      this.tileSectionTwo = 'GRC Consulting'
      this.descriptionSectionTwo = 'Our consulting team provides distinguished expertise in the field of governance, risk and compliance management to ensure that you have a clear vision of the current situation in your organization with regard to cyber security and data regulations in the Kingdom in addition to basic global controls'
    }
    if(cardActive !== 'Consultations' && cardActive !== 'Compliance' && cardActive !== 'Awareness'){
      this.cardSwap('Awareness')

      }
  }

}
